<script lang="ts">
  export let step: number;

</script>

<div class="fizz-full-width fizz-inset-horizontal-16">
  <ol
    class="fizz-progress-list fizz-margin-auto"
    style="max-width: 514px;"
    data-testid="application-step-counter"
  >
    <li class:fizz-is-active={step === 1} class:fizz-is-complete={step > 1} data-step="1 of 3">
      Account details
    </li>
    <li class:fizz-is-active={step === 2} class:fizz-is-complete={step > 2} data-step="2 of 3">
      Review and sign
    </li>
    <li class:fizz-is-active={step === 3} data-step="3 of 3">Verify and submit</li>
  </ol>
</div>
